import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button';
import {
	useHasActiveSubscription,
	useIsOwner,
	useIsTrialing
} from '@/hooks/user';
import Clock from '@/icons/clock.svg';
import LimitedDesktop1x from '@/images/limited/img-desktop-1x.png';
import LimitedDesktop2x from '@/images/limited/img-desktop-2x.png';
import routes from '@/routes';

function LimitedPlan() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const isTrialing = useIsTrialing();
	const hasUserActiveSubscription = useHasActiveSubscription();
	const isOwner = useIsOwner();
	const isBannerHidden = hasUserActiveSubscription || !isOwner;

	const messages = {
		guest: {
			title: t('myDocuments.limitedPlan.guestTitle'),
			description: t('myDocuments.limitedPlan.guestDescription')
		},
		trial: {
			title: t('myDocuments.limitedPlan.title'),
			description: t('myDocuments.limitedPlan.description')
		}
	};

	const currentMessages = messages?.[isTrialing ? 'trial' : 'guest'];

	if (isBannerHidden) {
		return null;
	}

	return (
		<div className="flex flex-col items-start justify-between rounded bg-red-background p-4 pb-0 md:mb-0 md:flex-row md:p-7 md:pb-0 md:pr-[39px]">
			<div className="flex flex-col pb-4 md:flex-row md:pb-7">
				<Clock
					aria-hidden
					className="h-6 w-6 text-red md:mt-2 md:h-8 md:w-8"
				/>
				<div className="mt-1 flex flex-col gap-1 md:ml-[19px] md:mt-0 md:w-[390px] md:gap-3">
					<h3 className="text-4 font-title font-semibold leading-7 md:text-[32px] md:leading-10">
						{currentMessages?.title}
					</h3>
					<p className="text-[10px] font-normal leading-4 md:text-xs md:leading-tight">
						{currentMessages?.description}
					</p>
				</div>
			</div>

			<img
				className="hidden pt-9 md:block md:pt-7"
				alt={t('myDocuments.limitedPlan.title')}
				src={LimitedDesktop1x}
				srcSet={`${LimitedDesktop1x} 1x, ${LimitedDesktop2x} 2x`}
				width="180"
				height="127"
			/>

			<div className="self-start pb-9 md:self-end md:pb-7">
				<Button
					className="px-3 text-[12px] leading-5"
					size="sm"
					onClick={() => {
						navigate(routes.billing, {
							state: { openChangePlanModal: isTrialing }
						});
					}}
				>
					{t('myDocuments.limitedPlan.button')}
				</Button>
			</div>
		</div>
	);
}

export default LimitedPlan;
